import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/auth';
import { getRateosCompanyList } from '../services/api_rateos';
import { addJustificationCustomCompany, getJustificationsCompanyList } from '../services/api_justifications';
import Swal from 'sweetalert2';
import Fetching from './fetching';
import { estraiMessaggiErrore } from '../services/utils';




const AddJustificationForm = ({ onCancel, onCreateJustificationCustom }) => {
    const [showForm, setShowForm] = useState(false);
    const { token } = useContext(AuthContext);
    const [formData, setFormData] = useState({});
    const [giustificativi, setGiustificativi] = useState([]);
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [strategy, setStrategy] = useState('');
    const [rateo, setRateo] = useState(null);
    const [hasHours, setHasHours] = useState(true);
    const [justificationConversions, setJustificationConversions] = useState('');
    const [rateiCompany, setRateiCompany] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showRateoSelect, setShowRateoSelect] = useState(false);
    const [formError, setFormError] = useState('');
    const [isSaving, setIsSaving] = useState(false);


    const handleCancel = () => {
        setCode('');
        setDescription('');
        setStrategy('');
        setRateo(null);
        setHasHours(true);
        onCancel();
    };

    useEffect(() => {
        const fetchRateiCompany = async () => {
            setIsLoading(true);
            setError(null);
        
            try {
                const rateiCompanyData = await getRateosCompanyList(token);
                setRateiCompany(rateiCompanyData);
            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchRateiCompany();
    }, [token]);

    
    const handleAddJustificationCustom = async (e) => {
        e.preventDefault();
        try {
            setIsSaving(true);

            if (!code || !description) {
                setFormError('Compila tutti i campi obbligatori');
                return;
            }
    
            const newStrategy = strategy || '';
    
            const newJustificationData = {
                code: code,
                description: description,
                strategy: newStrategy,
                rateo,
                has_hours: hasHours,
            };
    
            const response = await addJustificationCustomCompany(token, newJustificationData);
 
            const newJustification = {
                ...newJustificationData,
                id: response.id,
                rateo: rateiCompany.find(rc => rc.id === rateo),
            };
    
            onCreateJustificationCustom(newJustification);
    
            setCode('');
            setDescription('');
            setStrategy('');
            setRateo(null);
            setHasHours(true);
            setJustificationConversions('');
            setShowRateoSelect(false);
            setShowForm(false);
    
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Giustificativo creato con successo!",
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Errore durante l\'aggiunta del giustificativo:', error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: estraiMessaggiErrore(error) || "Errore nel salvataggio",
            });
        } finally {
            setIsSaving(false);
        }
    };
    
    if(isLoading)
        return <Fetching />
    if (error) return <div>Error: {error.message}</div>;
    
    return (
        <>
        {formError && <div className="text-red-500 text-sm text-center">{formError}</div>}
        <form
            className="grid md:grid-cols-2 sm:grid-cols-1 gap-7 mt-4"
            onSubmit={handleAddJustificationCustom} 
        >
            <div>
                <div className='flex justify-between'>
                    <label htmlFor="code" className="block text-sm font-medium text-gray-900">Codice *</label>
                    <label htmlFor="code" className="block text-sm font-medium text-gray-900">Formato: max 3 caratteri</label>
                </div>
                <input
                    type="text"
                    id="code"
                    name="code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    maxLength={3}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm placeholder:text-gray-400 placeholder:text-sm focus:border-blue-500 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    placeholder="Esempio: A12"
                    required
                />
            </div>
            <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-900">Descrizione *</label>
                <input
                    type="text"
                    id="description"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm placeholder:text-gray-400 placeholder:text-sm focus:border-blue-500 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    placeholder="Inserisci descrizione"
                    required
                />
            </div>

            <div>
                <label htmlFor="strategy" className="block text-sm font-medium text-gray-900">Strategia *</label>
                <select
                    id="strategy"
                    name="strategy"
                    value={strategy || ''}
                    onChange={(e) => {
                        const selectedValue = e.target.value;
                        setStrategy(selectedValue === '' ? null : selectedValue);
                    }}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    required
                >
                    <option value='null'>Nessuna azione</option>
                    <option value="increase">Aumenta</option>
                    <option value="decrease">Riduce</option>
                </select>
            </div>

            {strategy !== '' && (
                <div>
                    <label htmlFor="rateo" className="block text-sm font-medium text-gray-900">Rateo</label>
                    <select
                        id="rateo"
                        name="rateo"
                        value={rateo !== null ? rateo : ''}
                        onChange={(e) => setRateo(parseInt(e.target.value))}
                        className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    
                    >
                        <option value="">Seleziona un rateo</option>
                        {rateiCompany.map((rateo) => (
                            <option key={rateo.id} value={rateo.id}>{rateo.rateo.name}</option>
                        ))}
                    </select>
                </div>
            )}

            <div>
                <label htmlFor="has_hours" className="block text-sm font-medium text-gray-900">È frazionabile in ore *</label>
                <select
                    id="has_hours"
                    name="has_hours"
                    value={hasHours || ''}
                    onChange={(e) => {
                        const selectedValue = e.target.value;
                        setHasHours(selectedValue === '' ? null : selectedValue);
                    }}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    required
                >
                    <option value="true">Si</option>
                    <option value="false">No</option>
                </select>
            </div>

            <div className="md:col-span-2 sm:col-span-1 flex justify-center mt-5">
                <button
                    type="submit"
                    className={`border border-indigo-400 flex items-center rounded-md px-5 py-2 text-center text-sm font-semibold text-gray-700 shadow-sm focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 w-24 justify-center mr-3 bg-indigo-600 text-white ${
                        isSaving ? 'bg-gray-400 cursor-not-allowed text-gray-400' : 'bg-grey-400 hover:bg-indigo-400 hover:text-white'
                    }`}
                    onClick={handleAddJustificationCustom}
                    disabled={isSaving}
                >
                    {isSaving ? 'Salvataggio...' : 'Salva'}
                </button>
                <button
                    type="button"
                    onClick={handleCancel}
                    className="border border-gray-400 block rounded-md bg-grey-400 px-5 py-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 hover:bg-gray-400 hover:text-white w-24 justify-center"
                >
                    Annulla
                </button>
            </div>
        </form>
        </>
    );
};

export default AddJustificationForm;
